import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import React from 'react'
import { addPropsToChildren } from '../../lib/helpers'
import { SPACE_HALF, SPACE_QUARTER } from '../../lib/spaces'
export default function LayoutRow({
  children,
  vertical = false,
  reverse = false,
  alignStart = false,
  justifyEnd = false,
  gutter = 'none',
  justifyStart = false,
  dynamicStyle,
}) {
  return (
    <div
      className={css(
        styles.row,
        vertical && !reverse && styles.vertical,
        reverse && !vertical && styles.reverse,
        vertical && reverse && styles.verticalReverse,
        alignStart && styles.alignStart,
        justifyEnd && styles.justifyEnd,
        justifyStart && styles.justifyStart,
        gutter !== 'none' && styles[`gutter_${gutter}`],
        dynamicStyle
      )}
    >
      {addPropsToChildren(children, { gutter })}
    </div>
  )
}

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  gutter_small: {
    marginLeft: -SPACE_QUARTER,
    marginRight: -SPACE_QUARTER,
  },
  gutter_large: {
    marginLeft: -SPACE_HALF,
    marginRight: -SPACE_HALF,
  },
  vertical: {
    flexDirection: 'column',
  },
  reverse: {
    flexDirection: 'row-reverse',
  },
  verticalReverse: {
    flexDirection: 'column-reverse',
  },
  alignStart: {
    alignItems: 'flex-start',
    alignContent: 'flex-start',
  },
  justifyEnd: {
    justifyContent: 'flex-end',
  },
  justifyStart: {
    justifyContent: 'flex-start',
  },
})

LayoutRow.propTypes = {
  children: PropTypes.node.isRequired,
  vertical: PropTypes.bool,
  reverse: PropTypes.bool,
  alignStart: PropTypes.bool,
  justifyEnd: PropTypes.bool,
  justifyStart: PropTypes.bool,
  gutter: PropTypes.oneOf(['none', 'small', 'large']),
  dynamicStyle: PropTypes.object,
}
